import {GTM_CONFIG} from "@/config/google.analytics.config";
// import VueGtag from "vue-gtag";
import { createGtm } from "@gtm-support/vue-gtm";
import Clarity from '@/plugins/clarity'
export const initializeAnalytics = (app,router) => {
    app.use(
        createGtm({
            ...GTM_CONFIG,
            vueRouter: router
        })
    );
    app.use(Clarity);
    // app.use(
    //     VueGtag,
    //     {
    //         ...GTAG_CONFIG
    //     },
    //     router
    // );
}